import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CustomButtonV2, ModalFooter, ModalHeader, ModalSubHeader } from "../../../../pages/styles";
import { BackdropLoading } from "../../../BackdropLoading";

import { getImpactLevelRiskLevelOptions, getProbabilityRiskLevelOptions, getRiskLevelOptions, validateForm } from "../../../../utils/commonFunctions";

import { Body, Container, SectionRight, Spacer } from "./styles";
import { RiskControlForm } from "../../../molecules/forms/RiskControlForm";
import { getRiskMatrixValue } from "../../../../utils/commonFunctions/riskMatrixvalue";

export const RiskControlModalCard = ({ data, handleSave, handleClose, maxItem, matrizPng }) => {
    const { t } = useTranslation();

    const impactOptions = useMemo(() => getImpactLevelRiskLevelOptions(t), [t]);
    const probabilityOptions = useMemo(() => getProbabilityRiskLevelOptions(t), [t]);
    const riskOptions = useMemo(() => getRiskLevelOptions(t), [t]);

    const [form, setForm] = useState({
        item: '',
        description: '',
        impactLevel: '',
        probability: '',
        riskLevel: '',
        isActive: false,
    })
    const [errors, setErrors] = useState({
        item: { error: '', field: t('riskLevel.table.item'), required: true },
        description: { error: '', field: t('riskLevel.table.description'), required: true },
        impactLevel: { error: '', field: t('riskLevel.table.impactLevel'), required: true },
        probability: { error: '', field: t('riskLevel.table.probability'), required: true },
        riskLevel: { error: '', field: t('riskLevel.table.riskLevel'), required: true },
    })

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (data?.id) {
            setLoading(true);

            setForm(prev => ({
                ...prev,
                id: data.id,
                item: data.item,
                description: data.description,
                impactLevel: impactOptions.find(
                    o => o.code === data.impactLevel
                ) || null,
                probability: probabilityOptions.find(
                    o => o.code === data.probability
                ) || null,
                riskLevel: riskOptions.find(
                    o => o.code === data.riskLevel
                ) || null,
                isActive: data.isActive
            }));

            setLoading(false);
        }

    }, [data, impactOptions, probabilityOptions, riskOptions]);

    useEffect(() => {
        // Solo cuando es nuevo (no edición)
        if (!data?.id) {
            setForm(prev => ({
                ...prev,
                item: maxItem + 1
            }));
        }
    }, [data, maxItem]);

    function handleChange(event, name, limit) {
        if (name === "impactLevel" || name === "probability" || name === "riskLevel")
            setForm({ ...form, [name]: event })
        else {
            let value = event.target.value

            if (limit !== undefined && typeof limit === 'number') value = value.slice(0, limit)

            setForm({ ...form, [name]: value })
        }

        setErrors({ ...errors, [name]: { ...errors[name], error: '' } })
    }

    useEffect(() => {
        if (form.impactLevel && form.probability) {

            const riskCode = getRiskMatrixValue(
                form.impactLevel.code,
                form.probability.code
            );

            const riskOption = riskOptions.find(
                o => o.code.startsWith(`(${riskCode})`)
            );

            if (riskOption) {
                setForm(prev => ({
                    ...prev,
                    riskLevel: riskOption
                }));
            }


        }
    }, [form.impactLevel, form.probability, riskOptions]);



    function checkForm() {
        let validate = validateForm(form, errors)
        if (validate.hasErrors) {
            setErrors(validate.errors)
            return
        }
        handleSave(form)
    }

    const handleState = (value) => {
        let data = { ...form }
        setForm({
            ...data,
            isActive: value
        })
    }

    return (
        <Container>
            <ModalHeader>{data?.id ? t('riskLevel.modal.edit') : t('riskLevel.modal.create')}</ModalHeader>
            <ModalSubHeader/>
            <Body>
                <RiskControlForm
                    isNew={data.id == null}
                    form={form}
                    errors={errors}
                    handleChange={handleChange}
                    handleState={handleState}
                    maxItem={maxItem}
                    impactOptions={impactOptions}
                    probabilityOptions={probabilityOptions}
                    riskOptions={riskOptions}
                    matrizPng={matrizPng}
                />
            </Body>
            <ModalFooter>
                <SectionRight>
                    <CustomButtonV2
                        btnType="cancel"
                        onClick={() => handleClose(false)}
                    >
                        {t('common.cancel')}
                    </CustomButtonV2>
                    <Spacer />
                    <CustomButtonV2
                        btnType="primary"
                        onClick={checkForm}
                    >
                        {t('common.save')}
                    </CustomButtonV2>
                </SectionRight>
            </ModalFooter>
            <BackdropLoading open={loading} />
        </Container>
    )
}